import type { $Fetch } from 'ofetch';
import type { VideoaulaGateway } from '@/application/port/out/VideoaulaGateway';
import type { ListVideoaulasParams, UpsertVideoaulaCommand, Videoaula } from '@/domain/model/Videoaula';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/** Gateway HTTP de Videoaula — BE `/api/v1/videoaulas` (JSON). */
export class HttpVideoaulaGateway implements VideoaulaGateway {
  private readonly path = '/api/v1/videoaulas';
  constructor(private readonly client: $Fetch) {}

  async list(p: ListVideoaulasParams): Promise<Videoaula[]> {
    const params: Record<string, string> = {};
    if (p.disciplineId) params['disciplineId'] = p.disciplineId;
    const res = await this.client<ApiResponse<Videoaula[]>>(this.path, { method: 'GET', params });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertVideoaulaCommand): Promise<Videoaula> {
    const res = await this.client<ApiResponse<Videoaula>>(this.path, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertVideoaulaCommand): Promise<Videoaula> {
    const res = await this.client<ApiResponse<Videoaula>>(`${this.path}/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: cmd,
    });
    assertApiSuccess(res);
    return res.data;
  }

  async arquivar(id: string): Promise<void> {
    await this.client<void>(`${this.path}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
